const nameKey = (name) =>
  String(name ?? "")
    .normalize("NFC")
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase();

const isDuplicateName = (name, names = []) => {
  const key = nameKey(name);
  return key !== "" && names.some((other) => nameKey(other) === key);
};

const findDuplicateName = (newNames, existingNames = []) => {
  const seen = new Set(existingNames.map(nameKey));
  for (const name of newNames) {
    const key = nameKey(name);
    if (seen.has(key)) return String(name).trim();
    seen.add(key);
  }
  return null;
};

const duplicateNameMessage = (name) =>
  `Es gibt bereits eine Person namens „${String(name).trim()}“ in der Gruppe.`;

module.exports = {
  nameKey,
  isDuplicateName,
  findDuplicateName,
  duplicateNameMessage,
};
